type PrefixedString<P extends string, S extends string> = `${P}${S}`;

export const addPrefixToStringValues = <
  T extends readonly string[],
  P extends string,
>(
  array: T,
  prefix: P,
) => {
  return array.map((item) => `${prefix}${item}`) as {
    [K in keyof T]: T[K] extends string ? PrefixedString<P, T[K]> : never;
  };
};
